angular.module('impactx.rfx').service('RFQSearchService', RFQSearchService);

RFQSearchService.$inject = ['$rootScope', 'dataGen', '$context', '$q', 'searchFilter', '$redirect', 'ToastService', '$location',
    '$securityManager', 'TranslationService', 'RFXSupplierService', 'LoadingDialogService', '$mdDialog'];

function RFQSearchService($rootScope, dataGen, $context, $q, searchFilter, $redirect, ToastService, $location, $securityManager,
                         TranslationService, RFXSupplierService, LoadingDialogService, $mdDialog) {
    var pathWatcher;
    var self = this;
    var dialogData = {};

    function routeNotIncludedInRestrictedSearch(route) {
        return route.indexOf('search.product/vcat') < 0 &&
        route.indexOf('/search') !== 0 &&
        route.indexOf('/lot/') !== 0 &&
        route.indexOf('/search.lot') !== 0 &&
        route.indexOf('/tender/') !== 0 &&
        route.indexOf('/search.tender') !== 0 &&
        route.indexOf('/supplier/') !== 0 &&
        route.indexOf('/search.supplier') !== 0 &&
        route.indexOf('/vcatalog/') !== 0 &&
        route.indexOf('/search.vcatalog') !== 0 &&
        route.indexOf('productredirect/') < 0 &&
        route.indexOf('product/') < 0;
    }

    function activateRFQSSearch(params, redirect, noEdit) {
        dialogData = params;
        dataGen.postAsForm({}, {id: params.id, noEdit: noEdit ? !!noEdit : false}, "/rfx/activaterfqssearch").then(function (data) {
            searchFilter.listSearch.value = true;
            $context.refreshSearchInfo({}, dataGen, $context).then(function () {
                searchFilter.resetSearchFilter();
                searchFilter.listSearch.value = true;
                ToastService.openStandardToast(TranslationService.get('activatedRFQS'));
                if (redirect) {
                    $redirect.redirectTo(null, redirect);
                }
                else {
                    $redirect.redirectTo(null, "/search");
                }
                $context.rfqsBasketCount = 0;
                if (getDialogData() && getDialogData().data && getDialogData().data.contracts && getDialogData().data.contracts.length) {
                    for (var i = 0; i < getDialogData().data.contracts.length; i++){
                        var contract = getDialogData().data.contracts[i];
                        if (contract.items && contract.items.length) {
                            $context.rfqsBasketCount = $context.rfqsBasketCount + contract.items.length;
                        }
                    }
                }
            });
            if (pathWatcher) {
                pathWatcher();
            }
            pathWatcher = $rootScope.$watch(function () {
                return $location.path();
            }, function (newRoute, oldRoute) {
                if (newRoute !== oldRoute && routeNotIncludedInRestrictedSearch(newRoute)) {
                    deactivateRFQSSearchInternal(oldRoute);
                }
            });
        });
    }

    function activateRFQHSearch(params) {
        dialogData = params;
        dataGen.postAsForm({}, {id: params.id, rfqcId: params.rfqcId, supplierId: params.supplierId, tenderId: params.tenderId, lotId: params.lotId}, "/rfx/activaterfqhsearch").then(function (data) {
            searchFilter.listSearch.value = true;
            $context.refreshSearchInfo({}, dataGen, $context).then(function () {
                searchFilter.resetSearchFilter();
                searchFilter.listSearch.value = true;
                ToastService.openStandardToast(TranslationService.get('activatedRFQH'));
                $redirect.redirectTo(null, "/search");
            });
            if (pathWatcher) {
                pathWatcher();
            }
            pathWatcher = $rootScope.$watch(function () {
                return $location.path();
            }, function (newRoute, oldRoute) {
                if (newRoute !== oldRoute && routeNotIncludedInRestrictedSearch(newRoute)) {
                    deactivateRFQHSearchInternal(oldRoute);
                }
            });
        });
    }

    function deactivateRFQSSearchInternal(oldRoute) {
        deactivateRFQSSearch(true).then(function () {
            $context.refreshSearchInfo({}, dataGen, $context).then(function () {
                searchFilter.resetSearchFilter();
            });
        });
        if ($securityManager.isAuthorized()) {
            ToastService.openStandardToast(TranslationService.get('deactivatedRFQS'));
        }
    }
    function deactivateRFQHSearchInternal(oldRoute) {
        deactivateRFQHSearch(true).then(function () {
            $context.refreshSearchInfo({}, dataGen, $context).then(function () {
                searchFilter.resetSearchFilter();
            });
        });
        if ($securityManager.isAuthorized()) {
            ToastService.openStandardToast(TranslationService.get('deactivatedRFQH'));
        }
    }

    function deactivateRFQSSearch(deactivateOnBackend) {
        if (pathWatcher) {
            pathWatcher();
        }
        if (deactivateOnBackend) {
            if ($context.hasRFQSSearch && $context.hasRFQSSearch.value) {
                return dataGen.postAsForm({}, {}, "/rfx/deactivaterfqssearch");
            }
            else {
                return $q.when();
            }
        }
    }

    function deactivateRFQSSearchAndRedirect(deactivateOnBackend) {
        var rfqsId = $context.hasRFQSSearch.id;
        var rfqhId = $context.hasRFQSSearch.rfqhId;
        deactivateRFQSSearch(deactivateOnBackend).then(function () {
            $context.refreshSearchInfo({}, dataGen, $context).then(function() {
                ToastService.openStandardToast(TranslationService.get('deactivatedRFQS'));
                if (!$securityManager.isProcessAllowed("RFXSupplierView")) {
                    $redirect.redirectTo(null, "/rfxsuppliereditbuyer/" + rfqhId + "/" + rfqsId);
                }
                else {
                    $redirect.redirectTo(null, "/rfxsupplier/edit/" + rfqsId);
                }

                $location.replace();
            });
        })
    }

    function deactivateRFQHSearch(deactivateOnBackend) {
        if (pathWatcher) {
            pathWatcher();
        }
        if (deactivateOnBackend) {
            if ($context.hasRFQHSearch && $context.hasRFQHSearch.value) {
                return dataGen.postAsForm({}, {}, "/rfx/deactivaterfqhsearch");
            }
            else {
                return $q.when();
            }
        }
    }

    function addToRFQSInternal(item, rfqsDialogData) {
        RFXSupplierService.addItemToContracts(item, null, null, rfqsDialogData.data, true).then(function () {
            ToastService.openStandardToast(TranslationService.get('addSuccess'));
            LoadingDialogService.stop()
            $context.rfqsBasketCount++;
        }, function () {
            LoadingDialogService.stop()
        });
    }

    function addToRFQSSelectCSCorLot(event, item, rfqsDialogData) {
        LoadingDialogService.stop()
        RFXSupplierService.showContractOrLotSelectionDialog(event, item, rfqsDialogData.data.id, rfqsDialogData.trns).then(function (contractData) {
            LoadingDialogService.start();
            angular.extend(item, contractData);
            RFXSupplierService.addItemToContracts(item, null, null, rfqsDialogData.data, true).then(function () {
                ToastService.openStandardToast(TranslationService.get('addSuccess'));
                LoadingDialogService.stop()
                $context.rfqsBasketCount++;
            }, function () {
                LoadingDialogService.stop()
            });
        });
    }

    function addToRFQS(product, price, amount, event) {
        LoadingDialogService.start();
        if (!amount) {
            amount = 1;
        }
        var rfqsDialogData = getDialogData();
        dataGen.getData({}, {
            rfqsId: $context.hasRFQSSearch.id,
            proId: product.id,
            cscId: price.cscId ? price.cscId : 0,
            amount: amount
        }, "/rfx/supplier/newsupplieritem").then(function (data) {
            if (data && data.data) {
                var item = data.data;
                item.isEdited = true;
                var cscId = impactX.isDefined(item, 'csc.id');
                var lotId = impactX.isDefined(item, 'lot.id');
                if(price.askSupplier)
                {
                    LoadingDialogService.stop();
                    console.log(item);
                    $mdDialog.show({
                        templateUrl: "modules/rfxsupplier/templates/rfx-supplier-ask-price-supplier.dialog.html",
                        controller: "AddToRFQSAskSupplierCtrl",
                        controllerAs: "ctrl",
                        parent: angular.element(document.body),
                        targetEvent: event,
                        clickOutsideToClose: false,
                        bindToController: true,
                        locals: {
                            item: item,
                            rfqsId: $context.hasRFQSSearch.id,
                            event: event
                        }
                    }).then(function () {
                        LoadingDialogService.start();
                        if (cscId || lotId) {
                            addToRFQSInternal(item, rfqsDialogData);
                        }
                        else {
                            addToRFQSSelectCSCorLot(event, item, rfqsDialogData);
                        }
                    });
                }
                else if (cscId || lotId) {
                    addToRFQSInternal(item, rfqsDialogData);
                }
                else {
                    addToRFQSSelectCSCorLot(event, item, rfqsDialogData);
                }
            } else {
                ToastService.openStandardToast(TranslationService.get('amountIncreased'));
                LoadingDialogService.stop();
            }
        }, function () {
            LoadingDialogService.stop();
        });
    }

    function addToRFQH(product, amount) {
        if (!amount) {
            amount = 1;
        }
        amount = encodeURIComponent(amount);
        $redirect.redirectTo(null, dialogData.path + "/" + product.id + "/" + amount)
    }

    function getDialogData() {
        return dialogData;
    }

    return {
        deactivateRFQSSearch: deactivateRFQSSearch,
        deactivateRFQSSearchAndRedirect: deactivateRFQSSearchAndRedirect,
        activateRFQSSearch: activateRFQSSearch,
        addToRFQS: addToRFQS,
        deactivateRFQHSearch: deactivateRFQHSearch,
        activateRFQHSearch: activateRFQHSearch,
        addToRFQH: addToRFQH,
        getDialogData: getDialogData
    };
}